import React, { useState } from 'react';
import { actionIcons } from '../../../../configs/Icons';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { GetDate } from '../../../utils/Show';

function ShowGeneratedTokenModal() {
    const { modalData, setMessage } = useTemplate();
    const [isCopied, setIsCopied] = useState(false);

    const handleCopy = async (data) => {
        try {
            await navigator.clipboard.writeText(data || '');
            setIsCopied(true);
        } catch (err) {
            setMessage({ type: 'error', text: err.message });
        }
    };

    setTimeout(() => {
        setIsCopied(false);
    }, 5000);
    return (
        <div className="flex flex-col gap-3 mb-2">
            <div className="text-primary text-sm">
                &bull; Make sure to copy your personal access token now as you will not be able to
                see this again.
            </div>
            <div className="text-primary text-sm">
                &bull; This token will be used to access the API. Please keep it secure. Do not
                share it with anyone.
            </div>
            <div className="border border-primary-200 rounded-5 h-10 flex items-center bg-secondary-50">
                <input
                    type="text"
                    placeholder="Access token"
                    value={modalData?.token}
                    disabled
                    className="w-11/12 h-full outline-none border-none pl-2 text-sm bg-transparent text-primary-700 select-none"
                />
                <button
                    type="button"
                    onClick={() => handleCopy(modalData?.token || '')}
                    className="w-1/12 h-full p-2 bg-transparent border-l border-primary-200"
                >
                    {isCopied ? (
                        <img src={actionIcons.tickIconWL} alt="copy" className="size-full" />
                    ) : (
                        <img src={actionIcons.copyIconWL} alt="copy" className="size-full" />
                    )}
                </button>
            </div>
            <div className="text-primary-700 text-sm">
                Expires on: <span className="font-medium">{GetDate(modalData?.timeExpire)}</span>
            </div>
        </div>
    );
}

export default ShowGeneratedTokenModal;
